import 'polyfill'
import 'fbSDK'
import 'GTM'
import branch from 'branch-sdk'
import React, { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import configureStore from 'store/configureStore'
import * as serviceWorker from './serviceWorker'
import { roadie } from 'styles/themes'
import { ThemeProvider } from 'styled-components/macro'
import watchWindowSize from 'windowSize'
import { join } from 'util/path'
import { HelmetProvider } from 'react-helmet-async'

import { StaticLoader } from 'components/misc/Loader'

const key = process.env.REACT_APP_BRANCH_KEY
if(!key) {
  throw new Error('Set REACT_APP_BRANCH_KEY in the environment')
} else if(process.env.NODE_ENV !== 'test') {
  branch.init(key)
}

async function getApp() {
  if (process.env.REACT_APP_ROOT_MOUNT === 'track') {
    return await import(/* webpackChunkName: "track-app" */ './TrackApp')
  } else if (process.env.REACT_APP_ROOT_MOUNT === 'how-tos') {
    return await import(/* webpackChunkName: "how-tos-app" */ './how-tos/App')
  } else {
    return await import(/* webpackChunkName: "drive-and-send-app" */ './App')
  }
}

const App = lazy(() => getApp())

const initialState = {}

const store = configureStore(initialState)

export function absoluteURL(path) {
  const { appRootPath } = store.getState().config
  return join(appRootPath, path)
}

watchWindowSize(store)

ReactDOM.render(
  <Provider store={store}>
    <HelmetProvider>
      <ThemeProvider theme={roadie}>
        <Suspense fallback={<StaticLoader />}>
          <App />
        </Suspense>
      </ThemeProvider>
    </HelmetProvider>
  </Provider>, 
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
